import { memo } from "react";
import "./QuotationRoomLabel.scss";
import PropTypes from "prop-types";
import RoomCapacity from "app/pages/.shared/RoomCapacity.jsx";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const mergeRooms = rooms => {
	const result = [];

	rooms.forEach(room => {
		// eslint-disable-next-line no-unused-vars
		const { quantity, occupancy, ...rest } = room;
		const key = JSON.stringify(rest);

		const existing = result.find(r => {
			// eslint-disable-next-line no-unused-vars
			const { quantity: q, occupancy, ...otherRest } = r;
			return JSON.stringify(otherRest) === key;
		});

		if (existing) {
			existing.quantity += room.quantity;
		} else {
			result.push({ ...room });
		}
	});

	return result;
};

const QuotationRoomLabel = ({ rooms }) => {
	return (
		<>
			<div className="quotation-room-label">
				<div className="quotation-room-label__title">
					{mergeRooms(rooms)?.map((room, index) => (
						<Typography
							key={`${room.title}-${index}`}
							variant={TYPOGRAPHY_VARIANTS.XL}
							isBold
							className="quotation-room-label__room"
							data-testid="room-label"
						>
							{rooms.length > 1 && <span>{room.quantity}x</span>}
							<span>{room.title}</span>
							<span>
								{room?.area?.value > 0 &&
									`[${room.area.value} ${room?.area?.unit}]`}
							</span>
							{Object.keys(room?.occupancy)?.length > 0 && (
								<RoomCapacity
									adultCount={room.occupancy?.adults}
									babyCount={room.occupancy?.babies}
									childCount={room.occupancy?.children}
								/>
							)}
						</Typography>
					))}
				</div>
			</div>
		</>
	);
};

QuotationRoomLabel.propTypes = {
	rooms: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			quantity: PropTypes.number.isRequired,
			title: PropTypes.string.isRequired,
			area: PropTypes.shape({
				value: PropTypes.number,
				unit: PropTypes.string,
			}).isRequired,
			occupancy: PropTypes.shape({
				adults: PropTypes.number,
				children: PropTypes.number,
				babies: PropTypes.number,
			}),
		})
	).isRequired,
};

export default memo(QuotationRoomLabel);
